import React, { useState, useEffect, useContext } from "react";
import { Container, Form, Row, Col, Alert } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import { logActivity } from "../../../utils/LogActivity";
import { toast } from "react-toastify";
import { Authorization } from "../../../Context/Authorization";
const UpdatePresident = () => {
  const [vfcName, setVfcName] = useState([]);
  const [name, setName] = useState(""); // Member ID
  const [designation, setDesignation] = useState("President");
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [members, setMembers] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState("");
  const [previousMembers, setPreviousMembers] = useState([]); // State for previous members
  const [error, setError] = useState("");
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcName(data);
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [Api]);

  const handleVfcChange = async (event) => {
    setLoading(true);
    const vfcId = event.target.value;
    setSelectedVfc(vfcId);

    if (!vfcId) {
      setMembers([]);
      setPreviousMembers([]);
      setName(""); // Reset the name selection
      setError(""); // Clear any errors
      setLoading(false);
      return;
    }

    try {
      const config = Authorization();

      // Fetch members for the selected VFC
      const membersResponse = await fetch(
        `${Api}/api/members/getMembersByVFC/${vfcId}`,
        config
      );
      if (!membersResponse.ok) {
        throw new Error("Failed to fetch members for the selected VFC");
      }
      const membersData = await membersResponse.json();
      setMembers(membersData.members);

      // Fetch previous members added for the selected VFC
      const previousMembersResponse = await fetch(
        `${Api}/api/member/designation/previous-members`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...config.headers,
          },
          body: JSON.stringify({ vfcId }),
        }
      );
      if (!previousMembersResponse.ok) {
        throw new Error("Failed to fetch previous members");
      }
      const previousMembersData = await previousMembersResponse.json();
      setPreviousMembers(previousMembersData); // Set the state with previous members data
    } catch (error) {
      console.log("Error fetching members or previous presidents", error);
    } finally {
      setLoading(false); // Ensure loading state is reset regardless of success or failure
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!name || !selectedVfc) {
        setError("Please select a member and VFC");
        return;
      }
      const config = Authorization();
      const response = await fetch(`${Api}/api/member/designation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers,
        },
        body: JSON.stringify({
          id: name,
          name: members.find((member) => member._id === name).name,
          vfcId: selectedVfc,
          designation: "President",
          date,
          note,
        }),
      });

      const data = await response.json();
      await logActivity(
        userId,
        "Updated New President",
        "Update President Page",
        Api
      );

      if (response.ok) {
        toast.success("Designation updated successfully");

        setError("");

        // Clear form fields
        setSelectedVfc("");
        setName("");
        setDate("");
        setNote("");
        setMembers([]);
        setPreviousMembers([]);
      } else {
        setError(data.message);
        console.log("Error updating designation", data.message);
      }
    } catch (error) {
      console.log("Error updating designation", error);
      setError("An error occurred while updating the designation");
    }
  };

  return (
    <div>
      <Preloader loading={loading} />

      <div className="page-header">
        <h3 className="page-title">President</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              President
            </li>
          </ol>
        </nav>
      </div>
      <Container className="my-5">
        <>
          <Row>
            <Col md={8}>
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <p className="card-description">
                      Update VFC President Form
                    </p>
                    <form onSubmit={handleSubmit}>
                      {error && <Alert variant="danger">{error}</Alert>}
                      <Form.Group controlId="vfcName" className="mb-3">
                        <Form.Label>VFC Name</Form.Label>

                        <Form.Control
                          as="select"
                          value={selectedVfc}
                          onChange={handleVfcChange}
                        >
                          <option value="">Select VFC</option>
                          {vfcName.map((vfc) => (
                            <option key={vfc._id} value={vfc._id}>
                              {vfc.vfcName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="name" className="mb-3">
                        <Form.Label>Name</Form.Label>

                        <Form.Control
                          as="select"
                          placeholder="Select Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          disabled={members.length === 0}
                        >
                          <option value="">Select Name</option>
                          {members.map((member) => (
                            <option key={member._id} value={member._id}>
                              {member.name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="designation" className="mb-3">
                        <Form.Label>Designation</Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter Designation"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                          disabled
                        />
                      </Form.Group>

                      <Form.Group controlId="date" className="mb-3">
                        <Form.Label>Date</Form.Label>

                        <Form.Control
                          type="date"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group controlId="note" className="mb-3">
                        <Form.Label>Note</Form.Label>

                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter Note"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </Form.Group>

                      <button
                        type="submit"
                        className="btn btn-outline-primary btn-icon-text mt-3"
                      >
                        <i className="mdi mdi-file-check btn-icon-prepend"></i>
                        Submit
                      </button>
                      <button className="btn btn-light mt-3">Cancel</button>
                    </form>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <p className="breadcrumb-item active" aria-current="page">
                Previous Presidents
              </p>
              {previousMembers.length > 0 ? (
                <ul>
                  {previousMembers.map((member) => (
                    <li key={member._id}>
                      <strong>
                        {member.memberId.name} - {member.designation} (
                        {new Date(member.date).toLocaleDateString()})
                      </strong>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No previous members found</p>
              )}
            </Col>
          </Row>
        </>
      </Container>
    </div>
  );
};

export default UpdatePresident;
